// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/mml.jpg";
import blogImg3 from "../images/blog/img-3.jpg";
import blogImg4 from "../images/blog/img-4.jpg";
import blogImg5 from "../images/blog/img-5.jpg";
import blogImg6 from "../images/blog/img-6.jpg";
import blogImg7 from "../images/blog/img-7.jpg";
// import blogImg8 from "../images/blog/img-8.jpg";
// import blogImg9 from "../images/blog/img-9.jpg";
// import blogImg10 from "../images/blog/img-10.jpg";

import blogSingleImg1 from "../images/blog/img-11.jpg";
import blogSingleImg2 from "../images/blog/img-12.jpg";
import blogSingleImg3 from "../images/blog/img-13.jpg";





const blogs = [
    // {
    //     id: '1',
    //     title: 'Обсуждены перспективы сотрудничества с китайскими предпринимателями',
    //     title2: 'Express delivery is going to slow down in 2024.',
    //     tag: 'Surgery',
    //     slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
    //     screens: blogImg1,
    //     description: '20 февраля 2026 года предприятие приняло китайских предпринимателей.В ходе встречи были обсуждены новые логические направления и его реализация.Стороны договорились о поездке в Китай для достижения соглашения и внесения там.',
    //     author: 'Anne William',
    //     create_at: 'Sep 03, 2024',
    //     blogSingleImg: blogSingleImg1,
    //     comment: '35',
    //     day: '20 февраля 2026',
    //     month: 'MAR',
    //     blClass: 'format-standard-image',
    //     animation: '1200',
    //     catagori: 'Food and Beverages',
    // },
    {
        id: '2',
        title: 'Our company visited China on a business trip',
        title2: 'Will supply chains become supply circles?',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg2,
        description: 'Our company visited China on a business trip. Negotiations were held with our Chinese colleagues on new railway routes and tariffs. The parties came to an agreement.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '20 March 2026 ',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
    },
    {
        id: '3',
        title: 'Agreement reached on new railway routes and tariffs',
        title2: 'We ensures you the best quality services',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy',
        screens: blogImg3,
        description: 'During the business trip to China, productive negotiations with our Chinese partners took place. Issues of optimizing railway routes and revising tariff policy were discussed. Both parties came to a mutually beneficial agreement.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: 'April 12, 2026',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
    },
    {
        id: '4',
        title: 'ГАРАНТИЯ НА ВАШ ПРОДУКТ',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg1,
        description: 'Мы гордимся качеством наших услуг и предоставляем гарантии на все наши транспортные и логистические решения.  Наша компания гарантирует сохранность и своевременную доставку вашего груза, а также полное соответствие всех услуг заявленным стандартам. В случае возникновения непредвиденных ситуаций, мы оперативно решаем все вопросы и предоставляем компенсацию в соответствии с условиями договора.Наша цель – ваше полное удовлетворение, и мы делаем все возможное, чтобы вы чувствовали уверенность и спокойствие, доверяя нам свои грузы.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',

        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Food and Beverages',
    },
    {
        id: '5',
        title: 'ЗАКАЗ ЧЕРЕЗ СОЦСЕТИ',
        title2: 'Will supply chains become supply circles?',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg5,
        description: 'Мы идем в ногу со временем и предлагаем вам удобный способ заказать наши услуги через социальные сети. Теперь вы можете легко и быстро оформить заказ на доставку, хранение или любую другую услугу, просто написав нам в мессенджерах популярных соцсетей. Наши менеджеры оперативно ответят на ваши запросы, помогут выбрать оптимальное решение и предоставят всю необходимую информацию. Благодаря этому вы можете решать все транспортные задачи, не выходя из дома или офиса. Подписывайтесь на наши страницы в соцсетях, чтобы быть в курсе всех новостей и акций!',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',

        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
    },
    {
        id: '6',
        title: 'ГАРАНТИЯ НА ВАШ ПРОДУКТ',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg3,
        description: 'Мы гордимся качеством наших услуг и предоставляем гарантии на все наши транспортные и логистические решения.  Наша компания гарантирует сохранность и своевременную доставку вашего груза, а также полное соответствие всех услуг заявленным стандартам. В случае возникновения непредвиденных ситуаций, мы оперативно решаем все вопросы и предоставляем компенсацию в соответствии с условиями договора.Наша цель – ваше полное удовлетворение, и мы делаем все возможное, чтобы вы чувствовали уверенность и спокойствие, доверяя нам свои грузы.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Food and Beverages',
    },

    {
        id: '7',
        title: 'ЗАКАЗ ЧЕРЕЗ СОЦСЕТИ',
        title2: 'Will supply chains become supply circles?',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg7,
        description: 'Мы идем в ногу со временем и предлагаем вам удобный способ заказать наши услуги через социальные сети. Теперь вы можете легко и быстро оформить заказ на доставку, хранение или любую другую услугу, просто написав нам в мессенджерах популярных соцсетей. Наши менеджеры оперативно ответят на ваши запросы, помогут выбрать оптимальное решение и предоставят всю необходимую информацию. Благодаря этому вы можете решать все транспортные задачи, не выходя из дома или офиса. Подписывайтесь на наши страницы в соцсетях, чтобы быть в курсе всех новостей и акций!',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',

        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
    },





];
export default blogs;



